const projectsData = [
  {
    id: 1,
    icon: "/photos/ommale.svg",
    title: "منصة عمال",
    description:
      "منصة عمال - أول منصة يمنية متخصصة في ربط العمال والحرفيين المهرة بالعملاء في صنعاء وضواحيها ابحث وتواصل مع أمهر العمال والحرفيين في مختلف المهن والحرف مثل النجارة، الدهان،الإعلام والتصميم الرقمي والمزيد من المهن. رابط المنصة: <a href='https://www.ommale.com' target='_blank'>ommale.com</a>",
    tags: ["PostgreSQL", "ASP.NET CORE", "Next.js"],
  },
  {
    id: 2,
    icon: "/photos/drobalnamaa.png",
    title: "دروب النماء للصناعات البلاستيكية",
    description:
      "قمت بتطوير موقع تجاري لدروب النماء للصناعات البلاستيكية. رابط الموقع: <a href='https://www.drobalnamaa.com' target='_blank'>drobalnamaa.com</a>",
    tags: ["Tailwind css", "React", "Next.js"],
  },
  {
    id: 3,
    icon: "fa-solid fa-car",
    title: "نظام لإدارة رخص القيادة والمركبات (DVID System)",
    description: `تطوير نظام شامل لإدارة رخص القيادة وتسجيل المركبات باستخدام إطار عمل .Net Framework وقواعد بيانات SQL SERVER قمت بإنشائه بعد انتهائي من تعلم كورسات منصة <a href='https://programmingadvices.com' target='_blank'>ProgrammingAdvices</a>`,
    tags: ["NET Framework.", "SQL SERVER"],
    gradient: "bg-secondary",
    fullDescription: `
            <p>
                يهدف المشروع إلى توفير نظام متكامل لإدارة رخص القيادة وتسجيل المركبات باستخدام إطار عمل .Net Framework وقواعد بيانات SQL SERVER باستخدام نمط Three Architecture.
            </p>
            <p class="mt-3">
                <strong>المميزات الرئيسية:</strong>
            </p>
            <ul class="list-group list-group-flush mt-2">
                <li class="list-group-item">تسجيل رخص القيادة والسائقين/li>
                <li class="list-group-item">ادارة رخص القيادة مثل اصدارها وتجديدها</li>
                <li class="list-group-item">واجهات سهلة الاستخدام</li>
                <li class="list-group-item">نظام للمستخدمين والصلاحيات</li>
                <li class="list-group-item">تكامل مع قواعد البيانات</li>
                <li class="list-group-item">واجهات خاصة لاجراءاختبارات القيادة مثل الاختبار النظري واختبار صحةالعين والنظر </li>
            </ul>
            <p class="mt-3">
                <strong>التقنيات المستخدمة:</strong>
            </p>
            <div class="mt-2">
                <span class="badge bg-secondary me-2 mb-2">NET Framework.</span>
                <span class="badge bg-secondary me-2 mb-2">SQL SERVER</span>
            </div>
        `,
    screenshots: [
      "/Photos/DVLDPhotos/1.jpg",
      "/Photos/DVLDPhotos/2.jpg",
      "/Photos/DVLDPhotos/3.jpg",
      "/Photos/DVLDPhotos/4.jpg",
    ],
    // demoUrl: "https://example.com/learning-platform",
    codeUrl: "https://github.com/Salahaldeen77/DVLDSystem",
  },
  {
    id: 4,
    icon: "fa-solid fa-chart-line",
    title: "موقع ادارة الحسابات",
    description:
      "قمت بانشاء المشروع اثناء تعلمي حيث يوفر تطبيق ويب لإدارة الحسابات وادارة عمليات السحب والايداع والتحويل بين الحسابات باستخدام  ASP.NET Core MVC",
    tags: ["ASP.NET CORE", "SQL SERVER", "Bootstrap"],
    gradient: "bg-warning",
    fullDescription: `
            <p>
                قمت بانشاء المشروع اثناء تعلمي حيث يوفر تطبيق ويب لإدارة الحسابات وادارة عمليات السحب والايداع والتحويل بين الحسابات باستخدام  ASP.NET Core MVC
            </p>
            <p class="mt-3">
                <strong>التقنيات المستخدمة:</strong>
            </p>
            <div class="mt-2">
                <span class="badge bg-secondary me-2 mb-2">ASP.NET CORE MVC</span>
                <span class="badge bg-secondary me-2 mb-2">SQL SERVER</span>
                <span class="badge bg-secondary me-2 mb-2">Bootstrap</span>
            </div>
        `,
    screenshots: [
      "/Photos/AccountsPhotos/1.jpg",
      "/Photos/AccountsPhotos/2.jpg",
      "/Photos/AccountsPhotos/3.jpg",
    ],
    // demoUrl: "https://example.com/financial-dashboard",
    codeUrl: "https://github.com/Salahaldeen77/AccountWebMVC",
  },
];

export default projectsData;
